import { FC } from 'react';

import Umbrella from '@/assets/umbrella.svg?react';
import cn from '@/utils/cn';

import { useLingui } from '@lingui/react';

interface Props {
  className?: string;
}

const ProtectBadge: FC<Props> = ({ className }) => {
  const { i18n } = useLingui();

  return (
    <div
      className={cn(
        'flex items-center gap-3 rounded-md bg-gray-200 px-3.5 py-3 md:px-6',
        className
      )}
    >
      <Umbrella className="min-h-6 min-w-6" />
      <p
        className="caption-large"
        dangerouslySetInnerHTML={{
          __html: i18n.t(
            'Odbierasz pieniądze z <b> Helpfind Protect — 100% dostarczonych przelewów </b>'
          ),
        }}
      />
    </div>
  );
};

export default ProtectBadge;
